import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CoreModule } from '@core/core.module';
import { environment } from '@environment';
import { applyPolyfills, defineCustomElements as defineMedia } from '@wizbii/media/dist/loader';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeFr, 'fr');

const startModule = () =>
  platformBrowserDynamic()
    .bootstrapModule(CoreModule)
    .then(applyPolyfills)
    .then(() => {
      // Register web components

      defineMedia(window);
    })
    .catch((err) => console.error(err));

if (module['hot']) {
  startModule();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    startModule();
  });
}
